module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.3e87064b.ttf";